<template>
  <basic-container>
    <avue-crud
      v-if="avueCrudVisible"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.inspectplan_edit"
          :hidden="hideShutlyBtn(scope.row)"
          @click="openInspecttasklistEditDialog(scope.row)"
          >修改
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.inspectplan_view"
          @click="openCllectionItem(scope.row)"
          :hidden="hideApplyBtn(scope.row)"
          >巡检记录
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="rowDel(scope.row)"
          :hidden="hideShutlyBtn(scope.row)"
          >关闭
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      high="60%"
      title="巡检项记录"
      append-to-body
      :visible.sync="collectionItem"
      @closed="closedDialog"
    >
      <div style="height: 580px; overflow: auto;">
        <avue-crud
          :data="inspectionItemData"
          v-model="inspectionItemForm"
          ref="inspectionItemFormRef"
          :option="inspectionItemOption"
          :page.sync="inspectionItemPage"
          @search-change="inspectionItemSearchChange"
          @current-change="inspectionItemCurrentChange"
          @size-change="inspectionItemSizeChange"
          @on-load="inspectionOnLoad"
          @refresh-change="inspectionOnLoad"
        >
        </avue-crud>
      </div>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="openInspectplanEditDialogFlag"
      :modal-append-to-body="false"
      @close="quitInspecttasklistEditDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="inspecttasklistEditFormRef"
          v-model="inspecttasklistEditForm"
          :option="inspecttasklistEditOption"
          @submit="inspectTaskListEditSubmit"
        >
          <template slot="crud1" slot-scope="scope">
            <avue-crud
              ref="crud2"
              :data="data1"
              :option="option2"
              @selection-change="selectionChangeItem"
            >
            </avue-crud>
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitInspecttasklistEditDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  update,
  updateTaskStatus,
} from '@/api/v4ward/inspecttasklist/inspecttasklist';
import { getTaskprojectList } from '../../../api/v4ward/inspecttaskproject/inspecttaskproject';
import { mapGetters } from 'vuex';
import inspecttasklistEditOption from './inspecttasklist-edit-option';

export default {
  data() {
    return {
      inspecttasklistEditOption: inspecttasklistEditOption,
      openInspectplanEditDialogFlag: false,
      avueCrudVisible: false,
      inspecttasklistEditForm: {},
      inspectionItemData: [],
      inspectionItemQuery: {},
      collectionItem: false,
      inspectionItemForm: {},
      inspectionItemPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        editBtn: false,
        selection: false,
        columnBtn: false,
        refreshBtn: false,
        searchLabelWidth: 100,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '所属小区',
            prop: 'propertyId',
            type: 'tree',
            dataType: 'string',
            dicUrl: 'api/base/property/treeChildrenPowerNode',
            props: { label: 'objectFullName', value: 'id' },
            search: true,
          },
          {
            label: '巡检点位名称',
            prop: 'inspectNodeName',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            searchPlaceholder: '模糊匹配巡检点位名称',
          },
          {
            label: '班组名称',
            prop: 'groupId',
            type: 'tree',
            dicUrl: 'api/inspectGroup/inspectGroupTree',
            overHidden: true,
            props: { label: 'groupName', value: 'id' },
          },
          {
            label: '班组负责人',
            prop: 'groupPrincipalId',
            search: true,
            type: 'tree',
            dicUrl: 'api/blade-user/userTree',
            props: { label: 'realName', value: 'id' },
            disabled: true,
          },
          {
            label: '巡检点位Id',
            prop: 'nodeId',
            hide: true,
            editDisplay: false,
          },
          {
            label: '任务Id',
            prop: 'taskId',
            hide: true,
            editDisplay: false,
            rules: [
              {
                required: true,
                message: '请输入任务Id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '巡视开始时间',
            type: 'datetime',
            prop: 'inspectBeginTime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入巡视开始时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '巡视结束时间',
            type: 'datetime',
            prop: 'inspectEndTime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入巡视结束时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '任务状态',
            prop: 'taskStatus',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=task_list_status',
            disabled: true,
            props: { label: 'dictValue', value: 'dictKey' },
            search: true,
          },
          {
            label: '实际巡检时间',
            prop: 'actualInspectTime',
            disabled: true,
            width: 100,
          },
          {
            label: '实际巡检人',
            prop: 'actualUserId',
            search: true,
            type: 'tree',
            dicUrl: 'api/blade-user/userTree',
            props: { label: 'realName', value: 'id' },
          },
          {
            label: '是否异常',
            prop: 'errorFlag',
            type: 'select',
            search: true,
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=error_flag',
            props: { label: 'dictValue', value: 'dictKey' },
            disabled: true,
          },
          {
            label: '异常描述',
            prop: 'errorContent',
            overHidden: true,
            disabled: true,
          },
          // {
          //   label: '工单编号',
          //   prop: 'wordId',
          //   disabled: true,
          // },
          // {
          //   label: '工单进度（状态）',
          //   prop: 'repairStatus',
          //   disabled: true,
          // },
          // {
          //   label: '备注',
          //   prop: 'remark',
          //   overHidden: true,
          //   maxlength: 200,
          //   showWordLimit: true,
          // },
        ],
      },
      inspectionItemOption: {
        height: 'auto',
        calcHeight: 'auto',
        multiple: false,
        tip: false,
        menu: false,
        border: true,
        index: true,
        indexLabel: '序号',
        addBtn: false,
        selection: false,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '任务名称',
            prop: 'taskName',
            hide: true,
          },
          {
            label: '设备名',
            prop: 'equipmentName',
            editDisplay: true,
            addDisplay: false,
            disabled: true,
          },
          {
            label: '巡检内容',
            type: 'textarea',
            prop: 'inspectContent',
            span: 24,
            row: 4,
          },
          {
            label: '是否异常',
            prop: 'errorFlag',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=error_flag',
            props: { label: 'dictValue', value: 'dictKey' },
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.inspecttasklist_add, false),
        viewBtn: this.vaildData(this.permission.inspecttasklist_view, false),
        delBtn: this.vaildData(this.permission.inspecttasklist_delete, false),
        editBtn: this.vaildData(this.permission.inspecttasklist_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },

  activated() {
    this.avueCrudView();
    this.onLoad();
  },
  methods: {
    avueCrudView() {
      this.avueCrudVisible = false;
      setTimeout(() => {
        this.avueCrudVisible = true;
      }, 100);
    },
    quitInspecttasklistEditDialog() {
      this.$refs.inspecttasklistEditFormRef.resetForm();
      this.openInspectplanEditDialogFlag = false;
    },
    inspectTaskListEditSubmit(form, loading, done) {
      update(form).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
          this.quitInspecttasklistEditDialog();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    openInspecttasklistEditDialog(row) {
      this.inspecttasklistEditForm = row;
      this.openInspectplanEditDialogFlag = true;
    },
    // hideEditBtn(){
    //   return row.taskStatus === 2 || row.taskStatus === 3;
    // },
    hideShutlyBtn(row) {
      return row.taskStatus === 1 || row.taskStatus === 2;
    },
    hideApplyBtn(row) {
      //    --》隐藏【巡检记录】按钮
      return row.taskStatus !== 1;
    },
    openCllectionItem(row) {
      this.inspectionItemQuery.taskId = row.taskId;
      this.inspectionItemQuery.taskListId = row.id;
      this.inspectionOnLoad(this.inspectionItemQuery);
      this.collectionItem = true;
    },
    inspectionItemSearchChange() {
      this.inspectionItemPage.currentPage = 1;
      this.inspectionOnLoad();
    },
    inspectionItemCurrentChange(currentPage) {
      this.inspectionItemPage.currentPage = currentPage;
    },
    inspectionItemSizeChange(pageSize) {
      this.inspectionItemPage.pageSize = pageSize;
    },
    inspectionOnLoad() {
      this.loading = true;
      getTaskprojectList(
        Object.assign(
          { current: this.inspectionItemPage.currentPage, size: this.inspectionItemPage.pageSize },
          this.inspectionItemQuery
        )
      ).then(({ data }) => {
        this.inspectionItemPage.total = data.total;
        this.inspectionItemData = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据关闭?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return updateTaskStatus({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return updateTaskStatus({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.$route.query.taskId) {
        this.query.taskId = this.$route.query.taskId;
      }
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
